import { useTracking } from '@change-corgi/core/react/tracking';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

type Tip = {
	title: string;
	guideLink: string;
};
type Result = ModelHookResult<
	{
		tips: readonly Tip[];
	},
	{
		onTipLinkClick: (url: string) => void;
	}
>;

export function useTipsAndGuides(): Result {
	const {
		data: { tips },
	} = useHomepagePageData();

	const track = useTracking();
	return {
		data: { tips },
		actions: {
			onTipLinkClick: (url: string) => {
				void track('homepage_tips_and_guides_link_click', { url });
			},
		},
	};
}
